(function () {
  'use strict';

  /* Vindt het hoofd-productformulier van het thema (Shopify-standaard:
     action bevat /cart/add). Sluit ons eigen sticky-formulier uit. */
  function getMainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].hasAttribute('data-sticky-atc-form')) return forms[i];
    }
    return null;
  }

  function initStickyAtc(root) {
    if (!root || root.__stickyAtcInit) return;
    root.__stickyAtcInit = true;

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-sticky-atc-variants]').textContent);
    } catch (e) {
      variants = [];
    }

    var idInput = root.querySelector('[data-sticky-atc-id]');
    var qtyInput = root.querySelector('[data-sticky-atc-qty]');
    var minusBtn = root.querySelector('[data-sticky-atc-minus]');
    var plusBtn = root.querySelector('[data-sticky-atc-plus]');
    var currentEl = root.querySelector('[data-sticky-atc-current]');
    var compareEl = root.querySelector('[data-sticky-atc-compare]');
    var imageEl = root.querySelector('[data-sticky-atc-image]');
    var submitBtn = root.querySelector('[data-sticky-atc-submit]');
    var labelEl = root.querySelector('[data-sticky-atc-label]');

    var addText = labelEl ? labelEl.textContent.trim() : 'In winkelwagen';
    var soldOutText = root.getAttribute('data-soldout-text') || 'Uitverkocht';
    var syncing = false; // voorkomt oneindige lus bij aantal-sync

    function findVariant(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    /* Werkt prijs, afbeelding en knop bij op basis van de gekozen variant */
    function applyVariant(id) {
      var v = findVariant(id);
      if (!v) return;

      if (currentEl) currentEl.textContent = v.price;

      if (compareEl) {
        if (v.compare_at_raw && v.compare_at_raw > v.price_raw) {
          compareEl.textContent = v.compare_at_price;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (imageEl && v.image) {
        imageEl.src = v.image;
        imageEl.removeAttribute('srcset');
      }

      if (submitBtn && labelEl) {
        if (v.available) {
          submitBtn.disabled = false;
          labelEl.textContent = addText;
        } else {
          submitBtn.disabled = true;
          labelEl.textContent = soldOutText;
        }
      }
    }

    /* ---------- Variant-sync met het hoofdformulier ---------- */
    var lastVariantId = idInput ? idInput.value : null;

    function readMainVariant() {
      var mainForm = getMainForm();
      if (!mainForm) return null;
      var mainId = mainForm.querySelector('[name="id"]');
      return mainId ? mainId.value : null;
    }

    function syncVariantFromMain() {
      var newId = readMainVariant();
      if (newId && newId !== lastVariantId) {
        lastVariantId = newId;
        if (idInput) idInput.value = newId;
        applyVariant(newId);
      }
    }

    // Directe reactie op wijzigingen in selects/radio's
    document.addEventListener('change', syncVariantFromMain);
    // Lichte fallback voor thema's die de variant programmatisch zetten
    var variantPoll = setInterval(syncVariantFromMain, 500);
    root.__stickyAtcPoll = variantPoll;

    /* ---------- Aantal: knoppen + two-way sync ---------- */
    function getMainQty() {
      var mainForm = getMainForm();
      if (!mainForm) return null;
      return mainForm.querySelector('[name="quantity"]');
    }

    function setQty(val, mirror) {
      val = parseInt(val, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (qtyInput) qtyInput.value = val;

      if (mirror) {
        var mainQty = getMainQty();
        if (mainQty && parseInt(mainQty.value, 10) !== val) {
          syncing = true;
          mainQty.value = val;
          mainQty.dispatchEvent(new Event('change', { bubbles: true }));
          syncing = false;
        }
      }
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) - 1, true);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + 1, true);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQty(qtyInput.value, true);
      });
    }

    // Wijzigt het hoofd-aantal -> spiegel naar de sticky balk
    var mainQtyEl = getMainQty();
    if (mainQtyEl) {
      mainQtyEl.addEventListener('change', function () {
        if (syncing) return;
        setQty(mainQtyEl.value, false);
      });
    }

    /* ---------- Body-padding zodat de balk de footer niet bedekt ---------- */
    function adjustBodyPadding() {
      document.body.style.paddingBottom = root.offsetHeight + 'px';
    }
    adjustBodyPadding();
    window.addEventListener('resize', adjustBodyPadding);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(adjustBodyPadding);
      ro.observe(root);
      root.__stickyAtcRO = ro;
    }

    // Beginstaat goedzetten
    if (lastVariantId) applyVariant(lastVariantId);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sticky-atc]');
    for (var i = 0; i < roots.length; i++) initStickyAtc(roots[i]);
  }

  function cleanup(root) {
    if (!root) return;
    if (root.__stickyAtcPoll) clearInterval(root.__stickyAtcPoll);
    if (root.__stickyAtcRO) root.__stickyAtcRO.disconnect();
    document.body.style.paddingBottom = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ---------- Theme Editor ondersteuning ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sticky-atc]');
    if (root) initStickyAtc(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-sticky-atc]');
    cleanup(root);
  });
})();
